/**
 * useSectionLayoutMode
 *
 * Resolves how a tabbed panel should lay out its section navigation based on
 * the global SlidePanel fullscreen flag: a vertical sidebar in desktop
 * fullscreen, the horizontal `CollapsibleTabs` strip everywhere else. This is
 * the default-mode source for `DetailPanelLayout`, so any tabbed form rendered
 * inside a SlidePanel switches layouts automatically.
 */
import { useGeoMarkupStore } from '@/store';
import { useDeviceLayout } from './useDeviceLayout';

export interface SectionLayoutMode {
  mode: 'tabs' | 'sidebar';
  /** Convenience flag — true when the sidebar layout is active. */
  isSidebar: boolean;
}

export function useSectionLayoutMode(): SectionLayoutMode {
  const isFullscreen = useGeoMarkupStore(
    (state) => state.ui.slidePanel.isFullscreen
  );
  const { isMobile } = useDeviceLayout();

  const isSidebar = isFullscreen && !isMobile;
  return { mode: isSidebar ? 'sidebar' : 'tabs', isSidebar };
}
